import React, { Component } from 'react';
import * as qs from 'query-string';

import { Auth } from '../../support';
import ClienteBillingInfo from '../../admin/clientes/upsert/ClienteBillingInfo';

class ConfigBillinginfo extends Component {
  state = {
    data: {},
  };

  constructor(props) {
    super(props);

    const original = Auth.getData();
    const { override, cliente, user } = original || {};

    this.state = {
      data: {
        id: cliente.id,
        rfc: cliente.rfc,
        razon_social: cliente.razon_social,
        uso_cfdi: cliente.uso_cfdi,
        email: override ? cliente.email : user.email,
        regimen: cliente.metadata.regimen,
        updated_at: cliente.updated_at,
        direccion: cliente.metadata.direccion,
      },
    };
  }

  onComplete = async (info) => {
    if (!!info) {
      const original = Auth.getData();
      const { cliente } = original;

      const data = {
        ...original,
        cliente: {
          ...cliente,
          ...info,
        },
      };

      Auth.setData(data);
    }

    const query = qs.parse(this.props.location.search);

    setTimeout(() => {
      if (!!query.intro) {
        this.props.history.replace('/app/intro');
      } else {
        this.props.history.replace('/cuenta/config/activacion');
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  render() {
    const { data } = this.state;

    return (
      <>
        <div className="header">
          <h5>Datos Fiscales</h5>

          <div className="py-3">Esta información será usada para la facturación de tus consumos y/o compras.</div>
        </div>

        <ClienteBillingInfo
          data={data}
          onComplete={this.onComplete}
        />
      </>
    );
  }
}

export default ConfigBillinginfo;
